import { Component, OnInit ,Input,Output,EventEmitter,SimpleChanges,TemplateRef,ContentChild,HostListener} from '@angular/core';
import { menulist }  from '../../comm/class/status';
@Component({
  selector: 'r-table',
  templateUrl: './rtable.component.html',
  styleUrls: ['./rtable.component.css']
})
export class RtableComponent implements OnInit {
  @Input() data: any;
  @Output() callback: EventEmitter<any> = new EventEmitter();
  @ContentChild('operation_dk',{static: false}) operationTemplateRef_dk: TemplateRef<any>;
  @ContentChild('operation_mb',{static: false}) operationTemplateRef_mb: TemplateRef<any>;
  @HostListener('window:scroll', ['$event']) onScrollEvent($event){
    if(this.getYPosition($event) > 800)
      this.showbacktop = true;
    else
      this.showbacktop = false;
  }
  showbacktop: boolean = false;
  showsortool:boolean = false;
  sort_obj:{column:string,sort:string} = {column:'',sort:'0'}

  order_list_for_mb:menulist = [
    {id:'1',name:'小到大'},
    {id:'0',name:'大到小'},
  ]

  constructor() { }

  ngOnInit(): void {

  }

  ngOnChanges(changes: {[propKey: string]: SimpleChanges }) {
    this.sort_obj = this.data.sort_obj;
    if(this.data?.attribute && this.data.attribute.length>0){
      this.showsortool = this.data.attribute.some((item)=>{
        return item.sort == 1;
      })
    }
  }

  sort_fn(key,can_sort=1){
    if(can_sort){
      if(key==this.sort_obj.column){
        this.sort_obj.sort = this.sort_obj.sort == '0'?'1':'0';
      }else{
        this.sort_obj.column = key;
        this.sort_obj.sort = '0';
      }
      this.apply_it(); 
    }

  }

  apply_it(){
    this.callback.emit(this.sort_obj);   
  }


  getYPosition(e: Event): number {
    return (e.target as Element)['scrollingElement'].scrollTop;
  }

  go_top(){
    var btn_click = document.getElementById("go_top");
    const tmp = this.getOffset(btn_click);
		this.scrollAnimation(tmp.top,0);
  }

  getOffset (el) {
    const box = el.getBoundingClientRect();
    return{
      top: box.top + window.pageYOffset - document.documentElement.clientTop,
      left: box.left + window.pageXOffset - document.documentElement.clientLeft
    }
  }

  scrollAnimation(currentY, targetY) {
    let needScrollTop = targetY - currentY
    let _currentY = currentY
    setTimeout(() => {
      const dist = Math.ceil(needScrollTop / 10)
      _currentY += dist
      window.scrollTo(_currentY, currentY)
      if (needScrollTop > 10 || needScrollTop < -10) {
        this.scrollAnimation(_currentY, targetY)
      } else {
        window.scrollTo(_currentY, targetY)
      }
    }, 10)
  }
  

}
